"use client";

import { c as _c } from "react/compiler-runtime";
import { CreateDropWaveWrapper } from "@/components/waves/CreateDropWaveWrapper";
import WaveDropsAll from "@/components/waves/drops/wave-drops-all";
import MobileMemesArtSubmissionBtn from "@/components/waves/memes/submission/MobileMemesArtSubmissionBtn";
import PrivilegedDropCreator, { DropMode } from "@/components/waves/PrivilegedDropCreator";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiWave } from "@/generated/models/ApiWave";
import { getHomeFeedRoute } from "@/helpers/navigation.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { useWave } from "@/hooks/useWave";
import { selectEditingDropId } from "@/store/editSlice";
import { ActiveDropAction, ActiveDropState } from "@/types/dropInteractionTypes";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLayout } from "./layout/LayoutContext";
interface MyStreamWaveChatProps {
  readonly wave: ApiWave;
}
const MyStreamWaveChat: React.FC<MyStreamWaveChatProps> = t0 => {
  const $ = _c(32);
  const {
    wave
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const containerRef = useRef(null);
  const [initialDrop, setInitialDrop] = useState(null);
  const [searchParamsDone, setSearchParamsDone] = useState(false);
  const {
    isMemesWave
  } = useWave(wave);
  const editingDropId = useSelector(selectEditingDropId);
  const {
    isApp
  } = useDeviceInfo();
  const [activeDrop, setActiveDrop] = useState(null);
  let t1;
  let t2;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t1 = () => {
      const dropParam = searchParams?.get("serialNo");
      if (dropParam) {
        setInitialDrop(parseInt(dropParam));
        const params = new URLSearchParams(searchParams?.toString() || "");
        params.delete("serialNo");
        const href = params.toString() ? `${pathname}?${params.toString()}` : pathname || getHomeFeedRoute();
        router.replace(href, {
          scroll: false
        });
      } else {
        setInitialDrop(null);
      }
      setSearchParamsDone(true);
    };
    t2 = [searchParams, router, pathname];
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const {
    waveViewStyle
  } = useLayout();
  let t3;
  if ($[5] !== waveViewStyle) {
    t3 = waveViewStyle || {};
    $[5] = waveViewStyle;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const containerStyle = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setActiveDrop(null);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== wave) {
    t5 = [wave];
    $[8] = wave;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = (drop, partId) => {
      setActiveDrop({
        action: ActiveDropAction.REPLY,
        drop,
        partId
      });
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const onReply = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = (drop_0, partId_0) => {
      setActiveDrop({
        action: ActiveDropAction.QUOTE,
        drop: drop_0,
        partId: partId_0
      });
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const onQuote = t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = t9 => {
      const {
        drop: drop_1,
        partId: partId_1
      } = t9;
      onReply(drop_1, partId_1);
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const handleReply = t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = t10 => {
      const {
        drop: drop_2,
        partId: partId_2
      } = t10;
      onQuote(drop_2, partId_2);
    };
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const handleQuote = t9;
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setActiveDrop(null);
    };
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const onCancelReplyQuote = t10;
  if (!searchParamsDone) {
    return null;
  }
  let t11;
  if ($[15] !== activeDrop || $[16] !== initialDrop || $[17] !== wave.id) {
    t11 = <WaveDropsAll key={wave.id} waveId={wave.id} onReply={handleReply} onQuote={handleQuote} activeDrop={activeDrop} initialDrop={initialDrop} dropId={null} />;
    $[15] = activeDrop;
    $[16] = initialDrop;
    $[17] = wave.id;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== activeDrop || $[20] !== editingDropId || $[21] !== isApp || $[22] !== wave) {
    t12 = !(isApp && editingDropId) && <div className="tw-mt-auto"><CreateDropWaveWrapper><PrivilegedDropCreator activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} onDropAddedToQueue={onCancelReplyQuote} wave={wave} dropId={null} fixedDropMode={DropMode.BOTH} /></CreateDropWaveWrapper></div>;
    $[19] = activeDrop;
    $[20] = editingDropId;
    $[21] = isApp;
    $[22] = wave;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== isMemesWave || $[25] !== wave) {
    t13 = isMemesWave && <MobileMemesArtSubmissionBtn wave={wave} />;
    $[24] = isMemesWave;
    $[25] = wave;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== containerStyle || $[28] !== t11 || $[29] !== t12 || $[30] !== t13) {
    t14 = <div ref={containerRef} className="tw-w-full tw-flex tw-flex-col tw-overflow-y-auto tw-overflow-x-hidden lg:tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300 scroll-shadow tw-flex-grow" style={containerStyle}>{t11}{t12}{t13}</div>;
    $[27] = containerStyle;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
};
export default MyStreamWaveChat;